import { LocalizationSettings } from '../interfaces';

export function getCookieLocalizationSettings(): LocalizationSettings | null {
  // local store dan  persist:vision i oku
  const localizationSettings = localStorage.getItem('localizationSettings');
  if (!localizationSettings) {
    return null;
  }
  const parsedLocalizationSettings = JSON.parse(localizationSettings);
  return parsedLocalizationSettings as LocalizationSettings;
}
